export class InternalCertificationCommand {
    formData: FormData;

    constructor(name: string, providerId: string, validityPeriod: number, file: File, hasExpirationDate: boolean, targetCount: number) {
        this.formData = new FormData();

        this.formData.append('name', name);
        this.formData.append('provider[id]', providerId);
        if (hasExpirationDate) {
            this.formData.append('validity_period', validityPeriod.toString());
        }
        this.formData.append('file', file, file.name);
        this.formData.append('has_expiration_date', hasExpirationDate.toString());
        if (targetCount) {
            this.formData.append('certificate_target_count', targetCount.toString());
        }
    }
}
